export function getStartOfInterval(
  date: Date,
  quantizationInterval: number,
): Date;
export function getStartOfInterval(
  date: Date | null,
  quantizationInterval: number,
): Date | null;
export function getStartOfInterval(
  date: Date | null,
  quantizationInterval: number,
): Date | null {
  return (
    date &&
    new Date(
      Math.floor(date.getTime() / quantizationInterval) * quantizationInterval,
    )
  );
}
